import Image from 'global/Image';
import {
  SpecialMonitoringBannerContainer,
  SpecialMonitoringBannerContent,
} from './styled';

interface Props {
  onClick: () => void;
  title: string;
}

const SpecialMonitoringBanner = ({ onClick, title }: Props) => (
  <SpecialMonitoringBannerContainer onClick={onClick}>
    <SpecialMonitoringBannerContent>
      <p className="special-monitoring-banner__title">
        <span>Full Call Auction</span>
      </p>
      <p
        className="special-monitoring-banner__desc"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: title }}
      />
    </SpecialMonitoringBannerContent>
    <i className="icon-trading_back reverse" />
  </SpecialMonitoringBannerContainer>
);

export default SpecialMonitoringBanner;
